import { render, staticRenderFns } from "./adminStats.vue?vue&type=template&id=1a043a9c&scoped=true"
import script from "./adminStats.vue?vue&type=script&lang=js"
export * from "./adminStats.vue?vue&type=script&lang=js"
import style0 from "./adminStats.vue?vue&type=style&index=0&id=1a043a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a043a9c",
  null
  
)

export default component.exports